<script setup>
  import { useRoute } from 'vue-router'

  import { computed, onMounted } from 'vue'

  import { useAuthStore } from '@/features/auth/useAuthStore.js'
  import { useGeoStore } from '@/features/geo/useGeoStore.js'
  import LoadingBlocker from '@/features/layout/components/loading/LoadingBlocker.vue'
  import Spinner from '@/features/ui/components/Spinner.vue'

  const geoStore = useGeoStore()
  const authStore = useAuthStore()
  const route = useRoute()

  const isOnErrorPage = computed(() => route?.name === 'error' || route?.path?.includes('/error'))

  onMounted(() => {
    geoStore.getGeoData()
  })
</script>

<template>
  <div
    v-if="!isOnErrorPage && (geoStore.geoLoading || authStore.myDetailsLoading)"
    class="init-project"
  >
    <Spinner />
  </div>
  <div v-else>
    <RouterView />
  </div>

  <LoadingBlocker />
</template>

<style lang="scss" scoped>
  .init-project {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100dvh;
  }
</style>
